import type { SavedAnalyticsProfile } from '@/types'

export interface SavedInfluencer {
  id: string
  title: string
  snippet: string
  followers: number
  url: string
  savedDate: string
  username: string
  daysAnalyzed: number
  totalPosts: number
  responseCode: number
}

export function transformSavedAnalytics(profiles: SavedAnalyticsProfile[]): SavedInfluencer[] {
  return profiles.map(profile => {
    // Use target_username first, fallback to profile_overview.username
    const username = profile.target_username || profile.profile_overview?.username || 'unknown'
    
    return {
      id: profile.id,
      title: `@${username}`,
      snippet: profile.profile_overview?.full_name || `Instagram profile analysis for @${username}`,
      followers: profile.profile_overview?.followers || 0,
      url: `https://instagram.com/${username}`,
      savedDate: profile.processing_timestamp,
      username: username,
      daysAnalyzed: profile.days_analyzed,
      totalPosts: profile.total_posts,
      responseCode: profile.response_code
    }
  })
}

export function formatFollowers(count: number): string {
  if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`
  if (count >= 1000) return `${(count / 1000).toFixed(1)}K`
  return count.toString()
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })
} 